import React from 'react';
import PropTypes from 'prop-types';

class ReactTableRowConfirmationModal extends React.Component {
    render() {
        const {
            isDisplayed,
            content,
            cancelText,
            confirmText,
            onCancel,
            onConfirm,
        } = this.props;

        return (
            <div className='react-table__confirm'>
                <div className='react-table__confirm__text'>{content}</div>
                <div className='react-table__confirm__button-group'>
                    <button
                        type='button'
                        className='react-table__confirm__button'
                        onClick={(e) => onCancel(e)}
                    >
                        {cancelText}
                    </button>
                    <button
                        type='button'
                        className='react-table__confirm__button react-table__confirm__button--green react-table__confirm__button--uppercase'
                        onClick={(e) => onConfirm(e)}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        );
    }
}

// default props
ReactTableRowConfirmationModal.defaultProps = {
    isDisplayed: false,
    cancelText: 'Cancel',
    confirmText: 'Confirm',
};
// validate props
ReactTableRowConfirmationModal.propTypes = {
    isDisplayed: PropTypes.bool,
    cancelText: PropTypes.string,
    confirmText: PropTypes.string,
    content: PropTypes.string,
};

export default ReactTableRowConfirmationModal;
